module.exports = __webpack_public_path__ + "fonts/prospects.3ecf2310.eot";